import React, { useEffect, useState } from 'react';
import './ThankYouSection.css';
import mascot from '../../assets/images/resources/about-1-1.png';
import logo from '../../assets/images/resources/logo.png';

function ThankYouSection() {
    const [bookingDetails, setBookingDetails] = useState({
        moveDate: '',
        fromAddress: '',
        toAddress: '',
        packingServices: false
    });

    useEffect(() => {
        // Get booking details from URL parameters
        const params = new URLSearchParams(window.location.search);
        setBookingDetails({
            moveDate: params.get('moveDate') || 'Not specified',
            fromAddress: params.get('fromAddress') || 'Not specified',
            toAddress: params.get('toAddress') || 'Not specified',
            packingServices: params.get('packing') === 'true'
        });
    }, []);

    return (
        <section className="thank-you-section">
            <div className="container"
                style={{
                    padding: '40px 40px',
                }}
            >
                {/* Logo Section */}
                <div className="logo-container" style={{ 
                    marginBottom: '40px',
                    textAlign: 'center'
                }}>
                    <img src={logo} alt="Company Logo" style={{ maxWidth: '300px' }} />
                </div>

                <div className="row">
                    {/* Mascot moved to left side */}
                    <div className="col-lg-5">
                        <div className="mascot-container" style={{ 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center',
                            height: '100%'
                        }}>
                            <img 
                                src={mascot} 
                                alt="Happy Mascot" 
                                style={{ 
                                    maxWidth: '100%', 
                                    height: 'auto' 
                                }} 
                            />
                        </div>
                    </div>

                    {/* Content moved to right side */}
                    <div className="col-lg-7">
                        <div className="thank-you-content" style={{ textAlign: 'left' }}>
                            <h1 className="thank-you-title">Your Junk Matters to Us.</h1>
                            <p className="thank-you-message">
                            <strong>We've received your inquiry,</strong> and we're excited to help make your declutter a smooth and stress-free experience. 
                            At JUNK CHUCKERS, we believe junk removal is more than just chucking old furniture and boxes — it’s about freeing up space to make your life easier.
                            </p>

                            <p className="thank-you-message">
                            One of our junk removal specialists will reach out shortly to give you a quote and answer any questions you may have. 
                            <br /><br />
                            <strong>The JUNK CHUCKERS Team 🚛💨</strong>
                            <br /><br />
                            <strong>
                                P.S. We're happy to price match any written quote - we won't be beat! 
                            </strong>
                            </p>
                            
                            {/* <div className="booking-details">
                                <div className="details-box" style={{ 
                                    background: '#f8f9fa', 
                                    padding: '20px', 
                                    borderRadius: '8px',
                                    marginTop: '20px'
                                }}>
                                    <p><strong>Move Date:</strong> {bookingDetails.moveDate}</p>
                                    <p><strong>From:</strong> {bookingDetails.fromAddress}</p>
                                    <p><strong>To:</strong> {bookingDetails.toAddress}</p>
                                    <p><strong>Packing Services:</strong> {bookingDetails.packingServices ? 'Yes' : 'No'}</p>
                                </div>
                            </div> */}

                            {/* <div className="contact-info" style={{ marginTop: '30px' }}>
                                <p>Have questions? Contact us at:</p>
                                <p><strong>Phone:</strong> (555) 123-4567</p>
                                <p><strong>Email:</strong> support@yourmovingcompany.com</p>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ThankYouSection;
